import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import CustomCategoryCard from "../sharedComponents/customCategoryCards";
import { useTranslation } from "react-i18next";
import API_URL from "../../redux/constent";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import CustomLines from "./customLines";
import CustomBigText from "../sharedComponents/customBigText";
import CustomButton from "../sharedComponents/customButton";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllShopBrands } from "../../redux/reducer/shopBrandReducer";

// Custom CSS for the slider
const customStyles = `
  .choose-items-slider .slick-arrow {
    display: none !important;
  }
  .choose-items-slider .slick-dots {
    display: none !important;
  }
  .choose-items-slider .slick-track {
    display: flex;
    align-items: center;
  }
  .choose-items-slider .slick-slide {
    display: flex !important;
    justify-content: center;
    align-items: center;
    padding: 0 6px;
  }
  .choose-items-slider .slick-slide > div {
    width: 100%;
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
  .choose-items-slider .slick-list {
    padding: 0 10px;
  }
  
`;

const ChooseItemsSection = ({ onOpenPopup }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);
  const sliderRef = useRef(null);
  const timerRef = useRef(null);
  const direction = useLanguageDirection();
  const { allShopBrands, loading, error } = useSelector(
    (state) => state.shopBrand
  );
  // Custom arrow components
  const CustomPrevArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        onClick={onClick}
        className="absolute z-10 p-2 -translate-y-1/2 bg-white duration-300 hover:bg-custom-yellow top-1/2 rounded-full shadow-md left-[0px] group hidden md:block"
      >
        <ChevronDoubleLeftIcon className="w-8 h-8 text-black duration-300 group-hover:text-white" />
      </button>
    );
  };

  const CustomNextArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        onClick={onClick}
        className="absolute z-10 p-2 -translate-y-1/2 bg-white duration-300 hover:bg-custom-yellow top-1/2 rounded-full shadow-md right-[0px] group hidden md:block"
      >
        <ChevronDoubleRightIcon className="w-8 h-8 font-bold text-black duration-300 group-hover:text-white" />
      </button>
    );
  };

  // Slick settings
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 3000,
    rtl: direction === "rtl",
    cssEase: "ease-in-out",
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 5 } },
      { breakpoint: 1024, settings: { slidesToShow: 5 } },
      { breakpoint: 768, settings: { slidesToShow: 3, arrows: false } },
      { breakpoint: 640, settings: { slidesToShow: 3, arrows: false } },
      { breakpoint: 480, settings: { slidesToShow: 2, arrows: false } },
    ],
  };

  useEffect(() => {
    // const fetchCategories = async () => {
    //   try {
    //     const response = await axios.get(`${API_URL}/shoppingOption`);
    //     let fetchedCategories = [];
    //     if (Array.isArray(response.data.data)) {
    //       fetchedCategories = response.data.data;
    //     } else if (
    //       response.data.data.category &&
    //       Array.isArray(response.data.category)
    //     ) {
    //       fetchedCategories = response.data.data.category;
    //     }
    //     setCategories(fetchedCategories);
    //   } catch (error) {
    //     console.error("Error fetching categories:", error);
    //     setCategories([]);
    //   }
    // };
    // fetchCategories();
    dispatch(fetchAllShopBrands());
  }, []);

  const handlePause = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPause();
    }
    if (timerRef.current) clearTimeout(timerRef.current);
  };

  const handleResume = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.slickPlay();
      }
    }, 3000);
  };

  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.textContent = customStyles;
    document.head.appendChild(styleElement);
    return () => {
      if (document.head.contains(styleElement)) {
        document.head.removeChild(styleElement);
      }
    };
  }, []);
  // console.log(allShopBrands);
  return (
    <div
      className="relative max-container"
      dir={direction}
      onMouseEnter={handlePause}
      onMouseLeave={handleResume}
      onFocus={handlePause}
      onBlur={handleResume}
      onTouchStart={handlePause}
      onTouchEnd={handleResume}
      onTouchCancel={handleResume}
    >
      <div
        className={`relative z-20 flex flex-col items-center justify-center text-center max-container transition-opacity duration-1000`}
      >
        <CustomLines />
        <CustomBigText title={t("shoppingSection.title")} />
        <p
          className="mt-5 font-medium text-center text-gray-700"
          dir={direction}
        >
          {t("shoppingSection.description")}
        </p>
      </div>

      <div className="relative w-full mt-4 mb-8">
        {allShopBrands?.length > 0 ? (
          <Slider
            ref={sliderRef}
            {...sliderSettings}
            className="choose-items-slider"
          >
            {/* {console.log(allShopBrands)} */}
            {allShopBrands?.map((item, index) => (
              <div key={`${item._id}`}>
                <div className="flex-shrink-0 min-w-[160px] max-w-[160px] lg:min-w-[185px] lg:max-w-[185px] group">
                  <CustomCategoryCard
                    image={item?.img}
                    title={item?.title}
                    link={item?.link}
                  />
                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <p className="w-full text-center text-gray-500">
            No items found.
          </p>
        )}
      </div>
      <div className="w-full mt-5 mb-12 text-center">
        <CustomButton
          children={t("shoppingSection.buttonLabel")}
          icon={MagnifyingGlassIcon}
          onClick={onOpenPopup}
        />
      </div>
    </div>
  );
};

export default ChooseItemsSection;
